import { render, staticRenderFns } from "./view-edit.vue?vue&type=template&id=227c98b6&scoped=true"
import script from "./view-edit.vue?vue&type=script&lang=js"
export * from "./view-edit.vue?vue&type=script&lang=js"
import style0 from "./view-edit.vue?vue&type=style&index=0&id=227c98b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c98b6",
  null
  
)

export default component.exports